import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ProcessingCTABand() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-accent-500 via-accent-400 to-brand-600">
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.5'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      <div ref={ref} className={`container-page relative z-10 py-20 md:py-28 text-center scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-brand-800 mb-4">
          Ready to process with Freshhlock?
        </h2>
        <p className="text-brand-800/80 max-w-lg mx-auto mb-10 text-base md:text-lg leading-relaxed">
          Whether you harvest seafood, meat, or produce — standardise your output, command better prices, and plug into a network that moves.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="w-full sm:w-auto px-8 py-3.5 bg-brand-700 hover:bg-brand-800 text-paper-50 font-semibold text-sm rounded-lg transition-all hover:scale-[1.02] text-center whitespace-nowrap cursor-pointer"
          >
            Become a Processing Partner
          </Link>
          <Link
            to="/why-us"
            className="w-full sm:w-auto px-8 py-3.5 border-2 border-brand-800/30 hover:border-brand-800 text-brand-800 font-semibold text-sm rounded-lg transition-all hover:bg-brand-800/5 text-center whitespace-nowrap cursor-pointer"
          >
            Learn About the Network
          </Link>
        </div>
      </div>
    </section>
  );
}